import React from 'react';

const Pencil = () => (
  <svg width="10.605" height="10.605" viewBox="0 0 10.605 10.605">
    <path id="Icon_material-edit" data-name="Icon material-edit" d="M4.5,12.892V15.1H6.709l6.515-6.515L11.015,6.377ZM14.932,6.878a.587.587,0,0,0,0-.831L13.554,4.669a.587.587,0,0,0-.831,0L11.645,5.747l2.209,2.209,1.078-1.078Z" transform="translate(-4.5 -4.496)" fill="#ec1c24"/>
  </svg>
);

export default Pencil;